(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ImportConstructelDialogController', ImportConstructelDialogController);

    ImportConstructelDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'ImportConstructel'];

    function ImportConstructelDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, ImportConstructel) {
        var vm = this;

        vm.importConstructel = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.importConstructel.id !== null) {
                ImportConstructel.update(vm.importConstructel, onSaveSuccess, onSaveError);
            } else {
                ImportConstructel.save(vm.importConstructel, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('tmgApp:importConstructelUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dateCreation = false;

        vm.setCsv = function ($file, importConstructel) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        importConstructel.name = $file.name;
                        importConstructel.csv = base64Data;
                        importConstructel.csvContentType = $file.type;
                    });
                });
            }
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
